import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { toast } from 'react-toastify';
import Loader from '../../../Shared/Loader';
import logo from '../../../../assets/images/logo.jpeg';
import { useReactToPrint } from 'react-to-print';
import BusinessInfo from '../../../Shared/BusinessInfo';

const LoanLedgerReport = () => {
    const [loanAccounts, setLoanAcccounts] = useState([]);
    const [selectedLoanAccount, setSelectedLoanAccount] = useState([]);
    const [searchResult, setSearchResult] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [searchText, setSearchText] = useState();
    const [loanAccountLedger, setLoanAccountLedger] = useState([]);
    const [opening, setOpening] = useState(0);
    const [isLoaded, setIsLoaded] = useState(false)
    const [details, setDetails] = useState('');
    const [isFilter, setIsFilter] = useState(false);
    const componentRef = useRef();

    const date = new Date();
    const today = format(date, "yyyy-MM-dd");

    useEffect(() => {
        fetch(`https://servers.thakurgaonexpress.com/rupkotha/getloanaccounts`)
            .then(res => res.json())
            .then(data => {
                setLoanAcccounts(data);
                // setLoading(false)
            })
    }, [])

    const handleFilteredData = e => {
        e.preventDefault();
        const startDate = e.target.startDate.value;
        const endDate = e.target.endDate.value;
        const code = e.target.code.value;

        const options = {
            timeZone: 'Asia/Dhaka',
            hour12: false,
        };
        const currentTime = new Date().toLocaleString('en-US', options);

        const url = `https://servers.thakurgaonexpress.com/rupkotha/getloanledger?code=${code}&startDate=${startDate}&endDate=${endDate}`
        fetch(url)
            .then(res => res.json())
            .then(data => {
                setLoanAccountLedger(data.ledger);
                setOpening(data.opening);
                setIsFilter(true);
                setIsLoaded(true);
                setDetails({ startDate: startDate, name: selectedLoanAccount?.name, code: code, range: startDate + " to " + endDate, time: currentTime });
                // setLoading(false)
            })

    }

    const totalLoanTakenAmount = loanAccountLedger.reduce((total, currentValue) => {
        return total + parseInt(currentValue.taken);
    }, 0);

    const totalLoanReturnAmount = loanAccountLedger.reduce((total, currentValue) => {
        if (currentValue.return.length) {
            return total + parseInt(currentValue.return);
        } else {
            return total;
        }
    }, 0);


    const totalReturnAmount = loanAccountLedger.reduce((total, currentValue) => {
        return total + parseInt(currentValue.return);
    }, 0);

    console.log(totalReturnAmount);

    // if (loading) {
    //     return <Loader />
    // }
    const generatePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `Bank Statement Of ${details?.accountName}`,

    })


    const handleSearchResult = (event) => {
        setSearchText(event.target.value)
        const match = loanAccounts.filter(loanAccount => loanAccount.name.includes(searchText) ||
            loanAccount.name.toLowerCase().includes(searchText) || loanAccount.name.toUpperCase().includes(searchText));
        setSearchResult(match);
        setIsSearching(true);
    }

    const handleAddProductToInvoice = (loanAccount) => {
        setSelectedLoanAccount(loanAccount);
        setIsSearching(false)
        setSearchText('');
    }


    return (
        <div className='mx-2'>
            <h2 className='mt-8 text-center text-lg font-bold'>Loan Account Ledger Report</h2>
            <div className='flex flex-col lg:flex-row lg:justify-between lg:items-center'>
                <div className='lg:mt-28 mt-8 mr-2'>
                    <div className='flex flex-col lg:flex-row lg:justify-between lg:items-center'>
                        <div class="form-control w-80 lg:w-40 mx-auto">
                            <input onChange={handleSearchResult} value={searchText} type="text" placeholder="Search Loan Account" class="input text-xs input-bordered border-dark-purple w-80 mx-auto lg:w-60 max-w-xs" />
                        </div>
                    </div>
                    <div style={isSearching ? {} : { visibility: 'hidden' }} className={`grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 mx-auto gap-2 bg-gray-200 p-2 ${isSearching ? 'h-60' : "h-8"} w-80 overflow-auto`}>
                        {
                            isSearching ? searchResult.map(loanAccount =>
                                <label for="update-modal" onClick={() => handleAddProductToInvoice(loanAccount)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{loanAccount?.code}-{loanAccount?.name}</label>) :
                                loanAccounts.map(loanAccount =>
                                    <label for="update-modal" onClick={() => handleAddProductToInvoice(loanAccount)} style={{ width: '300px', height: '50px' }} className={`bg-black bg-opacity-40 p-3 text-white text-xs shadow-md flex justify-left items-center rounded-lg font-bold hover:bg-white hover:text-textPrimary cursor-pointer`}>{loanAccount?.code}-{loanAccount?.name}</label>)
                        }
                    </div>
                </div>
                <div className='flex justify-center items-center lg:mr-20'>
                    <form onSubmit={handleFilteredData} className='mt-12 flex flex-col lg:flex-row justify-center items-center'>
                        <div class="form-control w-full mx-auto lg:w-40 max-w-xs lg:mr-2">
                            <label class="label">
                                <span class="label-text">Starting Date</span>
                            </label>
                            <input name='startDate' defaultValue={today} type="date" class="input text-xs input-bordered w-full max-w-xs" required />
                        </div>
                        <div class="form-control w-full mx-auto lg:w-40 max-w-xs lg:mr-2">
                            <label class="label">
                                <span class="label-text">End Date</span>
                            </label>
                            <input name='endDate' defaultValue={today} type="date" class="input text-xs input-bordered w-full max-w-xs" required />
                        </div>
                        <div class="form-control w-80 lg:w-40 max-w-xs">
                            <label class="label">
                                <span class="label-text">Loan Account Code</span>
                            </label>
                            <div class="form-control w-80 lg:w-40">
                                <input name='code' type="text" defaultValue={selectedLoanAccount?.code} placeholder="Loan Account Code" class="input text-xs input-bordered border-dark-purple w-full lg:w-40 max-w-xs" />
                            </div>
                        </div>
                        <input type='submit' value='Search' className='btn btn-md btn-error w-80 mx-auto lg:w-20 text-white mt-4 lg:mt-9 lg:ml-2'/>
                    </form>
                </div>
            </div>
            {isLoaded && <div className='text-right'>
                <ReactHtmlTableToExcel
                    id="test-table-xls-button"
                    className="btn btn-error text-white btn-xs mt-2 lg:mt-0"
                    table="table-to-xls"
                    filename={`Bank Statement- ${details.accountName}`}
                    sheet={`bankstatement-${details.accountName}`}
                    buttonText="Export to exel" />
                <button className='btn btn-success btn-xs ml-2 text-white' onClick={generatePrint}>Print</button>
            </div>
            }
            {isLoaded && <div ref={componentRef}>
                <div className='flex justify-center items-center mt-8'>
                    <div>
                        <img src={BusinessInfo.img} className="w-20 lg:w-44 lg:mr-20 lg:mb-4" alt="" />
                    </div>
                    <div className='lg:mr-40'>
                        <h1 className='text-xl lg:text-4xl text-textPrimary text-center'>{BusinessInfo.fullName}</h1>
                      {/* <h1 className='text-sm lg:text-xl text-textPrimary text-center'>{BusinessInfo.dealer}</h1> */}
                        <h1 className='text-xs text-textPrimary text-center'>{BusinessInfo.address}</h1>
                        <h1 className='text-xs lg:text-xl text-textPrimary text-center'>{BusinessInfo.mobile}</h1>
                    </div>
                </div>
                <div class="flex items-center justify-between">
                    <hr class="border-b border-gray-300 w-full mt-4 mb-px" />
                    <hr class="border-b border-gray-300 w-full mt-4 mb-px" />
                </div>
                <div class="flex items-center justify-between">
                    <hr class="border-b border-gray-300 w-full my-px" />
                    <hr class="border-b border-gray-300 w-full my-px" />
                </div>

                <div className='text-left ml-20 mt-8 text-xs'>
                    <h4>Report Type: <span className='font-bold'>Loan Account Ledger Statement</span></h4>
                    <h4>Loan Account Name: {details?.name}</h4>
                    <h4>Loan Account Code: {details?.code}</h4>
                    <h4>Report Date Range: {details?.range}</h4>
                    <h4>Report Time: {details?.time}</h4>
                </div>

                <div className='mb-20'>
                    <div class="overflow-x-auto mt-8  text-xs">
                        <table id='table-to-xls' class="table w-full text-center shadow-xl rounded-lg">
                            <thead>
                                <tr>
                                    <th className='bg-primary text-white normal-case'>SL</th>
                                    <th className='bg-primary text-white normal-case'>Date</th>
                                    <th className='bg-primary text-white normal-case'>Invoice No</th>
                                    <th className='bg-primary text-white normal-case'>Loan Taken Amount</th>
                                    <th className='bg-primary text-white normal-case'>Loan Return Amount</th>
                                    <th className='bg-primary text-white normal-case'>Details</th>
                                </tr>

                            </thead>
                            <tbody>
                                {
                                    loanAccountLedger.map((loanAccount, index) => <tr>
                                        <td className='border border-primary'>{index + 1}</td>
                                        <td className='border border-primary'>{loanAccount?.date}</td>
                                        <td className='border border-primary'>{loanAccount?.takeninvoice ? loanAccount?.takeninvoice : loanAccount?.returninvoice}</td>
                                        <td className='border border-primary'>{loanAccount?.taken ? loanAccount?.taken : "-"}</td>
                                        <td className='border border-primary'>{loanAccount?.return ? loanAccount?.return : "-"}</td>
                                        <td className='border border-primary'>{loanAccount?.takenremarks ? loanAccount?.takenremarks : loanAccount?.returnremarks}</td>
                                    </tr>)
                                }

                            </tbody>
                            <tfoot>
                                <tr>
                                    <th className='bg-primary text-white normal-case'></th>
                                    <th className='bg-primary text-white normal-case'>Opening Balance On {details?.startDate}</th>
                                    <th className='bg-primary text-white text-sm'>{opening}</th>
                                    <th className='bg-primary text-white text-sm'>{totalLoanTakenAmount}</th>
                                    <th className='bg-primary text-white text-sm'>{totalReturnAmount}</th>
                                    <th className='bg-primary text-white text-sm normal-case'>Closing: {opening + totalLoanTakenAmount - totalReturnAmount}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                </div>

            </div>}
        </div>
    );
};

export default LoanLedgerReport;